import numeral from "numeral";

// ----------------------------------------------------------------------

export function fNumber(number) {
    return numeral(number || 0).format("0,0");
}

export function fNumber2(number) {
    return numeral(number || 0).format("0,0.00");
}

export function fCurrency(number) {
    return number ? numeral(number).format("$0,0.00") : numeral(0).format("$0,0.00");
}

export function fCurrencyAbsolute(number) {
    return number ? numeral(Math.abs(number)).format("$0,0.00") : numeral(0).format("$0,0.00");
}

function result(format, key = ".00") {
    const isInteger = format.includes(key);

    return isInteger ? format.replace(key, "") : format;
}

export function fPercent(number) {
    const format = number ? numeral(Number(number) / 100).format("0.0%") : "";

    return result(format, ".0");
}

export function fData(number) {
    const format = number ? numeral(number).format("0.0 b") : "";

    return result(format, ".0");
}

export function fCurrencySign(number) {
    const mark = Math.sign(number);
    let sign = "";

    if (mark === 1) {
        sign = "+";
    } else if (mark === -1) {
        sign = "-";
    }

    return sign + numeral(Math.abs(number)).format("$0,0.00");
}

export function fCurrencySign2(number) {
    const mark = Math.sign(number);
    let sign = "";

    if (mark === -1) {
        sign = "-";
    }

    return sign + numeral(Math.abs(number)).format("$0,0.00");
}

export function fNumberDecimal(value, decimal = 2) {
    return parseFloat(value || 0).toFixed(decimal);
}
